<template>
	<div>
        <vue-headful :title="'Dashboard Settings :: MeritEHS'" />

	    <h4 class="mt-2 mb-4">
	    	<ol class="breadcrumb font-weight-bold m-0">
	    		<li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                    <router-link :to="`/`">
                        <i class="fa fa-dashboard"></i> Dashboard
                    </router-link>
                </li>
                <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                    Settings
                </li>
	    	</ol>
	    </h4>

        <div class="card mb-4">
            <div class="card-header">
                My MeritEHS Dashboards ({{ myDashboards.length }})
            </div>
            <div class="card-body">
                <v-client-table ref="myDashboardTable" :data="myDashboards" :columns="columns" :options="options">

                    <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">

                        <router-link :to="`/dashboards/settings/create`" class="btn btn-default ml-2">
                            <i class="fa fa-plus-circle"></i> New
                        </router-link>

                        <div class="clearfix d-md-none d-block"></div>
                    </div>

                    <template slot="id" slot-scope="props">
                        <router-link :to="`/dashboards/settings/edit/${props.row.id}`" class="btn btn-xs btn-default">
                            <i class="fa fa-edit"></i> Edit
                        </router-link>
                        <router-link :to="`/dashboards/settings/delete/${props.row.id}`" class="btn btn-xs btn-default">
                            <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                        </router-link>
                    </template>

                    <template slot="dashboard_name" slot-scope="props">
                        <router-link :to="`/dashboards/settings/view/${props.row.id}`">
                            {{ props.row.dashboard_name }}
                        </router-link>
                    </template>

                    <template slot="is_global" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.is_global == 1">Global</label>
                        <label class="badge badge-secondary" v-else>Private</label>
                    </template>

                    <template slot="user_id" slot-scope="props">
                        {{ props.row.FirstName }} {{ props.row.LastName }}
                    </template>
                </v-client-table>
            </div>
        </div>

        <div class="card mb-4">
            <div class="card-header">
                Global MeritEHS Dashboards ({{ globalDashboards.length }})
            </div>
            <div class="card-body">
                <div class="alert alert-warning">
                    <div>
                        Global dashboards are those created and managed by system admins. You can subscribe to any of these to add them to your dashboard. Subscribing allows admins to make updates to the dashboard(s) as needed and have those updates automatically push to your dashboard.
                    </div>
                    <div v-if="$store.state.user.is_admin" class="mt-3">
                        As an admin, you can create and edit any global dashboard.
                    </div>
                </div>
                <v-client-table ref="myDashboardTable" :data="globalDashboards" :columns="columns" :options="options">
                    <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left" v-if="$store.state.user.is_admin">

                        <router-link :to="`/dashboards/settings/create?is_global=1`" class="btn btn-default ml-2">
                            <i class="fa fa-plus-circle"></i> New
                        </router-link>

                        <div class="clearfix d-md-none d-block"></div>
                    </div>

                    <template slot="id" slot-scope="props">
                        <router-link :to="`/dashboards/settings/edit/${props.row.id}`" class="btn btn-xs btn-default" v-if="$store.state.user.is_admin">
                            <i class="fa fa-edit"></i> Edit
                        </router-link>
                        <router-link :to="`/dashboards/settings/subscribe/${props.row.id}`" class="btn btn-xs btn-default">
                            <span v-if="props.row.is_subscribed">
                                <i class="fa fa-remove"></i> Unsubscribe
                            </span>
                            <span v-else>
                                <i class="fa fa-star"></i> Subscribe
                            </span>
                        </router-link>
                    </template>

                    <template slot="dashboard_name" slot-scope="props">
                        <router-link :to="`/dashboards/settings/view/${props.row.id}`">
                            {{ props.row.dashboard_name }}
                        </router-link>
                        <label class="badge badge-warning" v-if="props.row.is_subscribed">Subscribed</label>
                    </template>

                    <template slot="is_global" slot-scope="props">
                        <label class="badge badge-success">Global</label>
                    </template>

                    <template slot="user_id" slot-scope="props">
                        {{ props.row.FirstName }} {{ props.row.LastName }}
                    </template>
                </v-client-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                userId: this.$store.state.user.user_id,
                dashboards: [],

                columns: ['id', 'dashboard_name', 'user_id'],
                options: {
                    headings: {
                        id: 'Actions',
                        dashboard_name: 'Dashboard Name',
                        is_global: 'Global',
                        user_id: 'Owner',
                        created_at: 'Created',
                    },
                    perPageValues: [],
                    sortable: ['dashboard_name', 'created_at'],
                    columnsDropdown: false,
                    uniqueKey: 'id',
                },
            }
        },

        watch: {

        },

        computed: {
            //MY Dashboards
            myDashboards(){
                //SEtup
                var dashboards = [];

                //Loop and Build
                for (var i = 0; i < this.dashboards.length; i++)
                {
                    if(this.dashboards[i].user_id == this.userId)
                    {
                        dashboards.push(this.dashboards[i]);
                    }
                }

                //SEnd it
                return dashboards;
            },

            //Global Dashboards
            globalDashboards(){
                //SEtup
                var dashboards = [];

                //Loop and Build
                for (var i = 0; i < this.dashboards.length; i++)
                {
                    if(this.dashboards[i].is_global == 1)
                    {
                        dashboards.push(this.dashboards[i]);
                    }
                }

                //SEnd it
                return dashboards;
            }
        },

        methods: {

            getSettings() {
                this.$http.get('/dashboards/settings')
                .then(response => {
                    //Set it
                    this.dashboards = response.data.dashboards;
                })
                .catch(err => {

                });
            },

        },

        mounted() {
            //Get the SEttings
            this.getSettings()
        }
    }
</script>